import { get, writable } from 'svelte/store';
import { Poller } from '../common/poller';
import { deepCompare } from './util';
export class SessionStore {
    constructor(sessionRemoteRepository) {
        this.sessionRemoteRepository = sessionRemoteRepository;
        this.store = writable([]);
        this.poller = new Poller(() => this.poll());
        this.subscribe = this.store.subscribe;
        this.poller.start();
    }
    async poll() {
        const sessions = await this.sessionRemoteRepository.fetchSessions(true);
        const previous = get(this.store);
        if (!deepCompare(sessions, previous)) {
            this.store.set(sessions);
        }
    }
}
